import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";

export default function DateAndTimePickerNotification({
  value,
  disabled,
  setValue,
  min,
  max,
  is24HourFormat = false,
}) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DateTimePicker
        sx={{ width: "100%" }}
        minDateTime={min && dayjs(min)}
        maxDateTime={max && dayjs(max)}
        disabled={disabled}
        size="small"
        value={value && dayjs(value).isValid() ? dayjs(value) : null}
        onChange={(newValue) =>
          setValue(newValue ? newValue.toISOString() : null)
        }
        format={is24HourFormat ? "YYYY-MM-DD HH:mm" : "YYYY-MM-DD hh:mm A"}
        ampm={!is24HourFormat}
        slotProps={{
          actionBar: {
            actions: ["clear", "accept", "cancel"], // 👈 adds "Clear" button inside picker popup
          },
        }}
      />
    </LocalizationProvider>
  );
}
